import React from "react";
import { FEATURES_CONFIG } from "../../../featuresConfig";
import HoldAndWinIntroDialog from "../HoldAndWinIntroDialog/HoldAndWinIntroDialog";
import HoldAndWinReloadDialog from "../HoldAndWinReloadDialog/HoldAndWinReloadDialog";
import HoldAndWinOutroDialog from "../HoldAndWinOutroDialog/HoldAndWinOutroDialog";
import MaxWinDialog from "../MaxWinDialog/MaxWinDialog";
import FreeSpinIntroDialog from "../FreeSpin/FreeSpinIntroDialog/FreeSpinIntroDialog";

const Dialogs = () => {
  return (
    <>
      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <HoldAndWinIntroDialog />}
      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <HoldAndWinReloadDialog />}
      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <HoldAndWinOutroDialog />}
      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <MaxWinDialog />}
      {FEATURES_CONFIG.FREE_SPINS.ENABLED && <FreeSpinIntroDialog />}
    </>
  );
};

export default Dialogs;

